import StructuredDataTable, { parseStructuredValue } from "./StructuredDataTable";

export default function OperationsActionResult({ value, fallback = "Action completed; verification was not recorded." }) {
  const parsed = parseStructuredValue(value);
  if (parsed !== null && typeof parsed === "object") {
    return <div className="mt-1"><StructuredDataTable data={parsed} /></div>;
  }
  const text = parsed === null || parsed === undefined || parsed === "" ? fallback : String(parsed);
  return <p className="mt-0.5 text-[11px] text-muted-foreground">{text}</p>;
}
